/**
 * @fileoverview Main JavaScript entry point.
 * Initializes Alpine.js framework and the ViewHandler for the application.
 * Handles any exceptions during the initialization process.
 */

import Alpine from "alpinejs";
import ViewHandler from './ViewHandler';
import lity from "lity";
import './jqueryScripts';

try {
    window.Alpine = Alpine;
    ViewHandler.init();
    Alpine.start();
} catch (e) {
    console.error(e);
}

